import _slicedToArray from "/home/runner/work/muhrusdi.github.io/muhrusdi.github.io/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as e from "react";
export function useSize(r) {
  var _e$useState = e.useState(void 0),
      _e$useState2 = _slicedToArray(_e$useState, 2),
      i = _e$useState2[0],
      t = _e$useState2[1];

  return e.useEffect(function () {
    if (r) {
      var _e = new ResizeObserver(function (e) {
        if (!Array.isArray(e)) return;
        if (!e.length) return;
        var i = e[0];
        var o, n;

        if ("borderBoxSize" in i) {
          var _e2 = i.borderBoxSize,
              _r = Array.isArray(_e2) ? _e2[0] : _e2;

          o = _r.inlineSize, n = _r.blockSize;
        } else {
          var _e3 = r.getBoundingClientRect();

          o = _e3.width, n = _e3.height;
        }

        t({
          width: o,
          height: n
        });
      });

      return _e.observe(r, {
        box: "border-box"
      }), function () {
        t(void 0), _e.unobserve(r);
      };
    }
  }, [r]), i;
}